import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-5v-6c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v6H5a1 1 0 100 2h14a1 1 0 100-2h-1z" fill="#444" /></svg>;